var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pt-password-setting',{ref:"form",staticClass:"pt-password-setting__withData",on:{"getCode":_vm.getCode,"editUserPassword":_vm.editUserPassword}})
}
var staticRenderFns = []

export { render, staticRenderFns }